var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ELink',{attrs:{"href":_vm.learnMoreUrl,"rel":"noopener","target":"_blank","data-test-id":"ad-learn-more"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.$t('common.generic.learnmore'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }